import { css, ThemedCssFunction } from 'styled-components'

// type cssFunction = (strings: TemplateStringsArray, ...interpolations: SimpleInterpolation[]) => InterpolationValue[]

// tslint:disable:object-literal-sort-keys

export const media: { tablet: ThemedCssFunction<any>, desktop: ThemedCssFunction<any> } = {
  tablet: (strings: any, ...args: any) => css`@media (min-width: 768px) { ${css(strings, ...args)} }`,
  desktop: (strings: any, ...args: any) => css`@media (min-width: 1025px) { ${css(strings, ...args)} }`,
  // largeDesktop: (...args) => css`@media (min-width: 1200px) { ${css(...args)} }`,
}

// tslint:enable:object-literal-sort-keys



// WEBPACK FOOTER //
// ./src/utils/media.ts